/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TooltipContent/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TooltipContent({
  children,
  viewPath = "/App/Account/Content/Tasks/New/Content/Board/Content/Main/Board/Board/Content/StageHeader/Sort/TooltipContent"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let sortSelectedValueData = fromData.useDataFormat({ viewPath,
context: 'sort',
path: 'selected',
format: fromHelpers.hasFilter,
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(sortSelectedValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}